// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3Lkj5","col":"Table_col__23rqf","fulfillmentStatus":"Table_fulfillmentStatus__NKrl5","emailCol":"Table_emailCol__1YF8h"};